import React, { useState } from "react";
import { useAuth } from "../Management/AuthContext";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { FaUser, FaLock } from "react-icons/fa"; // Import icon từ react-icons
import login3 from "../../assets/images/NewEvent/login3.webp";

export default function ButtonLogin() {
  const { login } = useAuth();
  const [activeTab, setActiveTab] = useState("login");
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const handleTabChange = (tab) => {
    setActiveTab(tab);
    setUsername("");
    setPassword("");
    setErrorMessage("");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!username || !password) {
      setErrorMessage("Vui lòng nhập đầy đủ thông tin.");
      return;
    }

    const apiEndpoint =
      activeTab === "login"
        ? "https://api-bluerise.bluerise.com.vn/auth/login"
        : "";

    try {
      const response = await axios.post(apiEndpoint, {
        username,
        password,
      });

      if (response.status === 200) {
        login({
          username,
          displayName: response.data.displayName,
          token: response.data.token,
        });

        toast.success(`Chào mừng, ${response.data.displayName}!`, {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
      } else {
        setErrorMessage("Đã xảy ra lỗi.");
        toast.error("Đăng nhập thất bại!", {
          position: "top-right",
          autoClose: 3000,
        });
      }
    } catch (error) {
      setErrorMessage("Đã xảy ra lỗi.");
      toast.error("Đăng nhập thất bại!", {
        position: "top-right",
        autoClose: 3000,
      });
    }
  };

  return (
    <div
      className="flex justify-center items-center w-full h-screen p-6 bg-center bg-cover bg-fixed"
      style={{
        backgroundImage: `url(${login3})`,
      }}
    >
      <ToastContainer />

      <div className="bg-green-200 rounded-lg w-[600px] shadow-lg border-2 border-gray-300 p-8 animate-fade-in">
        <div className="flex items-center justify-center mb-6">
          <button
            className={`px-6 py-2 text-[24px] font-semibold transition-all ${
              activeTab === "login"
                ? "font-bold text-blue-600 border-b-4 border-blue-600"
                : "text-gray-500 hover:text-blue-600"
            }`}
            onClick={() => handleTabChange("login")}
          >
            Đăng Nhập
          </button>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          {/* Trường nhập username với biểu tượng */}
          <div className="relative">
            <FaUser className="absolute left-3 top-3 text-gray-400 text-lg" />
            <input
              type="text"
              className="w-full pl-10 p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all"
              placeholder="Nhập tài khoản"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
            />
          </div>

          {/* Trường nhập password với biểu tượng */}
          <div className="relative">
            <FaLock className="absolute left-3 top-3 text-gray-400 text-lg" />
            <input
              type={showPassword ? "text" : "password"}
              className="w-full pl-10 p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all"
              placeholder="Nhập mật khẩu"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            <button
              type="button"
              className="absolute inset-y-0 right-4 flex items-center text-gray-500 hover:text-blue-500"
              onClick={() => setShowPassword(!showPassword)}
            >
              {showPassword ? "Ẩn" : "Hiện"}
            </button>
          </div>

          {/* Hiển thị thông báo lỗi */}
          {errorMessage && (
            <p className="text-red-500 text-sm animate-shake">{errorMessage}</p>
          )}

          {/* Nút submit */}
          <button
            type="submit"
            className="w-full px-4 py-3 bg-gradient-to-r from-blue-500 to-blue-600 text-white rounded-lg font-medium hover:from-blue-600 hover:to-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-1 transition-all shadow-lg"
          >
            {activeTab === "login" ? "Đăng Nhập" : "Đăng Ký"}
          </button>
        </form>
      </div>
    </div>
  );
}
